import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../../contexts/ThemeContext';
import DashboardShell from './DashboardShell';
import ActivityFeed from './ActivityFeed';
import NeedsAttention from './NeedsAttention';
import RecentWins from './RecentWins';

const DashboardIndex: React.FC = () => {
  const navigate = useNavigate();
  const { darkMode } = useTheme();

  const sectionClass = `rounded-lg shadow-lg border-l-4 p-4 ${
    darkMode ? 'bg-gray-800 border-indigo-600' : 'bg-white border-indigo-500 shadow-sm'
  }`;

  return (
    <DashboardShell title="The Pulse">
      {(_dateRange) => (
        <div className="relative">
          {/* Ambient background glow */}
          <div className="absolute -top-20 -left-20 w-64 h-64 bg-purple-600/5 rounded-full blur-3xl pointer-events-none" />
          <div className="absolute -top-10 -right-20 w-48 h-48 bg-blue-600/5 rounded-full blur-3xl pointer-events-none" />

          {/* Activity Feed */}
          <div className="mb-8">
            <h2 className="text-lg font-semibold mb-3 bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-purple-400">
              Recent Activity
            </h2>
            <div className={{sectionClass}}>
              <ActivityFeed />
            </div>
          </div>

          {/* Needs Attention + Recent Wins */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
            <div>
              <h2 className="text-lg font-semibold mb-3 bg-clip-text text-transparent bg-gradient-to-r from-amber-400 to-red-400">
                Needs Attention
              </h2>
              <div className={{sectionClass}}>
                <NeedsAttention />
              </div>
            </div>
            <div>
              <h2 className="text-lg font-semibold mb-3 bg-clip-text text-transparent bg-gradient-to-r from-green-400 to-emerald-400">
                Recent Wins
              </h2>
              <div className={{sectionClass}}>
                <RecentWins />
              </div>
            </div>
          </div>

          {/* Quick Actions */}
          <div className="flex gap-3">
            {[
              { label: 'Forge New Persona', path: '/personas/forge' },
              { label: 'Create Workflow', path: '/workflows/new' },
              { label: 'New Artifactory Project', path: '/artifactory' },
            ].map(action => (
              <button
                key={action.label}
                onClick={() => navigate(action.path)}
                className={`px-4 py-2.5 text-sm rounded-lg border transition-all duration-200 hover:translate-y-[-1px] ${
                  darkMode
                    ? 'bg-gray-800/80 text-gray-300 hover:bg-gray-700 border-gray-700 hover:border-purple-600/40 hover:shadow-md hover:shadow-purple-900/10'
                    : 'bg-white text-gray-600 hover:bg-gray-50 border-gray-200 hover:border-purple-300 hover:shadow-md'
                }`}
              >
                {action.label}
              </button>
            ))}
          </div>
        </div>
      )}
    </DashboardShell>
  );
};

export default DashboardIndex;
